<template>
    <g>
        <path
            d="M14.5712 17.5573C14.9617 17.9478 14.9617 18.581 14.5712 18.9715L11.7428 21.7999L10.3286 20.3857L12.4499 18.2644L10.3286 16.1431L11.7428 14.7289L14.5712 17.5573Z"
        />
        <path d="M16 21.7197H21.5115V19.7197H16V21.7197Z" />
        <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M27 8C27 6.89543 26.1046 6 25 6H7C5.89543 6 5 6.89543 5 8V24C5 25.1046 5.89543 26 7 26H25C26.1046 26 27 25.1046 27 24L27 8ZM25 12.0193L25 24H7L7 12.0193L25 12.0193ZM25 10.0193V8L7 8L7 10.0193L25 10.0193Z"
        />
    </g>
</template>
